import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2'
import axios from 'axios'
import qs from 'qs'
import components from './components'
import filters from './filters'
import plugins from './plugins'
import router from './router'
import 'admin4b/src/js'
import { REQUEST_TOKEN_INTERCEPTOR } from './interceptors/requests'
import VueTheMask from 'vue-the-mask'
import extensions from './extensions'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

axios.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'indices' })
}

Vue.config.productionTip = false

Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.use(components)
Vue.use(filters)
Vue.use(plugins)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2)
Vue.use(VueTheMask)
Vue.use(extensions)

new Vue({
  router,
  render: h => h(App),
  beforeCreate () {
    axios.interceptors.request.use(...REQUEST_TOKEN_INTERCEPTOR)
  }
}).$mount('#app')
